import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonHttpService } from '../../shared/http/json-http.service';
import { PartnerSystem } from '../models';

@Injectable({
    providedIn: 'root'
})
export class PartnerSystemService {
    constructor(private httpService: JsonHttpService) { }

    getAllPartnerSystems(): Promise<PartnerSystem[]> {
        return this.httpService.get('/api/partners/system/get-systems').toPromise();
    }

    savePartnerSystem(partnerSystem: PartnerSystem): Promise<PartnerSystem> {
        return this.httpService.post('/api/partners/system/save-system', partnerSystem).toPromise();
    }

    deletePartnerSystem(id: number): Promise<void> {
        const options = { params: new HttpParams().set('id', `${id}`) };
        return this.httpService.post('/api/partners/system/delete-system', null, options, false).toPromise();
    }
}
